<page-header [title]="pageTitle" [subtitle]="subtitle"></page-header>

<div class="row" *ngIf="!loading">
  <div class="col-lg-12">
    <div class="detail-container">
      <div class="subscription-panel" *ngIf="!hasFree">
        <div class="subscription-panel__content">
          <div>
            <div class="subscription-panel__title">
              {{
                hasActiveSubscription
                  ? "Manage your subscription and payment details"
                  : "Review your subscription status"
              }}
            </div>
            <div class="subscription-panel__meta">
              <span>Current Plan:</span>
              <strong>{{ currentPlan }}</strong>
            </div>
            <div
              class="subscription-panel__meta"
              *ngIf="renewalDate && !cancelDate"
            >
              <span>Next Renewal Date:</span>
              <strong>{{ renewalDate! * 1000 | date: "dd MMMM yy" }}</strong>
            </div>
            <div class="subscription-panel__meta" *ngIf="cancelDate">
              <span>Cancellation Date:</span>
              <strong>{{ cancelDate! * 1000 | date: "dd MMMM yy" }}</strong>
            </div>
            <div class="subscription-panel__note" *ngIf="cancelDate">
              You can continue enjoying Remy up to this date. Upgrade to any of
              our plans to continue thereafter.
            </div>
            <div class="subscription-panel__meta" *ngIf="hasTrial">
              <span>Your trial ends in</span>
              <strong>{{
                trialEnds + " day" + (trialEnds > 1 ? "s" : "")
              }}</strong>
            </div>
          </div>

          <div class="subscription-panel__actions">
            <app-primary-button
              (click)="openBillingPortal()"
              title="My Billing Portal"
              [disabled]="loading"
              bgColor="var(--app-timber)"
              color="white"
            ></app-primary-button>
            <div
              class="subscription-panel__helper"
              *ngIf="hasActiveSubscription"
            >
              Update payment methods, invoices and subscription details in
              Stripe.
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <!-- <div
          class="col-md-6"
          [ngStyle]="{
            'text-align': (isHandset$ | async) ? 'center' : 'left',
            'margin-bottom': (isHandset$ | async) ? '10px' : '0px'
          }"
        >
          <app-button-toggle-group
            [selectedType]="currency"
            (selectType)="toggleCurrency($event)"
            [options]="options"
          ></app-button-toggle-group>
        </div> -->
        <div
          [ngStyle]="{
            'text-align': (isHandset$ | async) ? 'center' : 'right',
          }"
        >
          <app-button-toggle-group
            [selectedType]="basis"
            (selectType)="toggleBasis($event)"
            [options]="typeOptions"
          ></app-button-toggle-group>
        </div>
      </div>

      <div class="plans-section-header" *ngIf="hasActiveSubscription">
        <div class="plans-section-header__title">Change plan</div>
        <div class="plans-section-header__subtitle">
          Looking to upgrade or downgrade? Compare the available plans below.
        </div>
      </div>

      <div class="row justify-content-center plan-cards-row">
        <div class="col-xl-4" *ngFor="let plan of plans">
          <plan-card
            [enabled]="!hasFree"
            [plan]="plan"
            [currency]="currency"
            [basis]="basis"
            (buttonTapped)="checkout($event)"
            [loading]="saving || loading"
          ></plan-card>
        </div>
      </div>
    </div>
  </div>
</div>

<loader [loading]="loading"></loader>
